document.addEventListener('click', function handleVariantSwatchClick(e) {

  const swatch = e.target.closest('.js-variant-swatch-item');

  if (!swatch) return;

  const template = swatch.querySelector('template');

  if (!template) return;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = template.innerHTML;

  const img = tempDiv.querySelector('img');

  if (!img) return;

  const variantUrl = img.getAttribute('data-url');

  if (!variantUrl) return;

  const card = swatch.closest('.product-card');

  if (!card) return;

  /* UPDATE PRODUCT LINKS */

  const linkClass = swatch.dataset.productLinkClass;

  if (linkClass) {

    card.querySelectorAll(`.${linkClass}`).forEach(link => {
      link.setAttribute('href', variantUrl);
    });

  }

  /* UPDATE MAIN IMAGE */

  const imageId = swatch.dataset.productImageId;

  if (imageId) {

    const mainImage = card.querySelector(`#${imageId}`);

    if (mainImage && mainImage.tagName === 'IMG') {

      mainImage.src = img.src;

      if (img.srcset) {
        mainImage.srcset = img.srcset;
      }

    }

  }

  /* UPDATE SECOND / HOVER IMAGE */

  const secondImage = card.querySelector('.product__image-second img');

  const secondImageSrc = img.getAttribute('data-second-image');
  const secondImageSrcset = img.getAttribute('data-second-image-srcset');

  if (secondImage && secondImageSrc) {

    secondImage.src = secondImageSrc;

    if (secondImageSrcset) {
      secondImage.srcset = secondImageSrcset;
    }

  }

  /* UPDATE QUICK SHOP URL */

  const quickShopBtn = card.querySelector('.quickbuy__btn');

  if (quickShopBtn) {

    quickShopBtn.setAttribute(
      'data-product-url',
      `${variantUrl}&view=quick-view`
    );

  }

  /* ACTIVE SWATCH */

  card.querySelectorAll('.js-variant-swatch-item').forEach(btn => {
    btn.classList.remove('is-active', 'btn-active');
  });

  swatch.classList.add('is-active', 'btn-active');

});

// Newsletter Submission Popup
document.addEventListener('DOMContentLoaded', function() {

  const urlParams = new URLSearchParams(window.location.search);

  if (!urlParams.has('customer_posted')) return;

  const isFrench = document.documentElement.lang.startsWith('fr');

  const popupHtml = `
    <div id="newsletter-success-popup" class="newsletter-success-popup">
      <div class="newsletter-success-popup__overlay"></div>

      <div class="newsletter-success-popup__content">

        <button class="newsletter-success-popup__close">&times;</button>

        <img srcset="//lyaactive.com/cdn/shop/files/lya-active-logo.png?v=1778050142&amp;width=70, //lyaactive.com/cdn/shop/files/lya-active-logo.png?v=1778050142 2x"
             src="//lyaactive.com/cdn/shop/files/lya-active-logo.png?v=1778050142&amp;width=400"
             class="newsletter-popup-logo mb-12"
             width="70"
             height="70"
             alt="LYA Active"
             loading="eager"
             fetchpriority="high"
             decoding="async">

        <h3 class="mb-12">
          ${isFrench ? 'Bienvenue chez LYA Active.' : 'Welcome to LYA Active.'}
        </h3>

        <p>
          ${isFrench
            ? 'Des essentiels haut de gamme conçus pour le mouvement, la confiance et l’équilibre.'
            : 'Elevated essentials designed for movement, confidence, and balance.'}
        </p>

        <p>
          ${isFrench
            ? 'Merci de vous joindre à nous.'
            : 'Thank you for joining us.'}
        </p>

        <p><strong>Lift Your Aura.</strong></p>

      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', popupHtml);

  document
    .querySelector('.newsletter-success-popup__close')
    ?.addEventListener('click', closePopup);

  document
    .querySelector('.newsletter-success-popup__overlay')
    ?.addEventListener('click', closePopup);

  function closePopup() {
    document.getElementById('newsletter-success-popup')?.remove();

    const url = new URL(window.location);

    url.searchParams.delete('customer_posted');

    window.history.replaceState({}, '', url.pathname + url.search);
  }

});

// Language Translator for EN/FR only
document.addEventListener('click', function(e) {

  const toggle = e.target.closest('.language-toggle');
  if (!toggle) return;

  e.preventDefault();

  const targetLang = toggle.dataset.lang;
  const url = new URL(window.location.href);

  if (targetLang === 'fr') {

    if (!url.pathname.startsWith('/fr')) {
      url.pathname = '/fr' + url.pathname;
    }

  } else {

    url.pathname = url.pathname.replace(/^\/fr/, '') || '/';

  }

  window.location.href = url.toString();

});

// Color Filters Redirectionc for mega menu links
// document.addEventListener('click', function (e) {

//   if (!document.documentElement.lang.startsWith('fr')) return;

//   const link = e.target.closest('a');

//   if (!link) return;

//   const href = link.getAttribute('href');

//   if (!href) return;

//   // Match both relative and absolute collection URLs
//   if (
//     href.includes('/collections/') &&
//     !href.includes('/fr/collections/')
//   ) {

//     e.preventDefault();

//     const url = new URL(href, window.location.origin);

//     window.location.href = '/fr' + url.pathname + url.search;

//   }

// }, true);